module.exports = __webpack_public_path__ + "img/logo_just_p.ba151126.png";